import script from "./RedirectCta.vue?vue&type=script&setup=true&lang=js"
export * from "./RedirectCta.vue?vue&type=script&setup=true&lang=js"

import "./RedirectCta.vue?vue&type=style&index=0&id=afd2f7ac&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afd2f7ac"]])

export default __exports__